import React from "react";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import type { KafkaEventTopic } from "../../types";
import { EntityStatus } from "../../types";

interface KafkaEventExplorerViewsProps {
  topic: KafkaEventTopic;
}

export const KafkaEventExplorerCard: React.FC<KafkaEventExplorerViewsProps> = ({
  topic,
}) => {
  return (
    <Card
      variant="outlined"
      sx={{
        height: "100%",
        borderRadius: 2,
        transition: "box-shadow 0.2s",
        "&:hover": { boxShadow: 3 },
      }}
    >
      <CardActionArea
        component={RouterLink}
        to={`/kafka-event-explorer/${topic.uuid}`}
        sx={{ height: "100%", alignItems: "stretch" }}
      >
        <CardContent>
          <Box sx={{ display: "flex", gap: 1, mb: 1, flexWrap: "wrap" }}>
            <Chip
              label={topic.status}
              size="small"
              color={topic.status === EntityStatus.ACTIVE ? "success" : "default"}
            />
            <Chip label={topic.environment} size="small" variant="outlined" />
            <Chip label={topic.schemaFormat} size="small" variant="outlined" />
          </Box>
          <Typography
            variant="h6"
            fontWeight={600}
            gutterBottom
            title={topic.name}
            sx={{ wordBreak: "break-word" }}
          >
            {topic.name}
          </Typography>
          {topic.purpose && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {topic.purpose}
            </Typography>
          )}
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export const KafkaEventExplorerListRow: React.FC<KafkaEventExplorerViewsProps> = ({
  topic,
}) => {
  return (
    <Box
      component={RouterLink}
      to={`/kafka-event-explorer/${topic.uuid}`}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        p: 2,
        borderBottom: "1px solid",
        borderColor: "divider",
        textDecoration: "none",
        color: "inherit",
        "&:hover": { bgcolor: "action.hover" },
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography fontWeight={600} noWrap>
          {topic.name}
        </Typography>
        <Typography variant="body2" color="text.secondary" noWrap>
          {topic.environment} · {topic.schemaFormat}
          {topic.schemaVersion ? ` · v${topic.schemaVersion}` : ""}
        </Typography>
      </Box>
      <Chip
        label={topic.status}
        size="small"
        color={topic.status === EntityStatus.ACTIVE ? "success" : "default"}
      />
    </Box>
  );
};
